module.exports = __webpack_public_path__ + "img/certification_background.0343248f.png";